import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  VoteOnPoll200,
  VoteOnPollBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Vote on a poll
 */
export const voteOnPoll = (
    pollId: string,
    voteOnPollBody: VoteOnPollBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<VoteOnPoll200>(
      {url: `https://api.ugot.uk/api/polls/${pollId}/vote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voteOnPollBody
    },
      options);
    }
  


export const getVoteOnPollMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteOnPoll>>, TError,{pollId: string;data: VoteOnPollBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof voteOnPoll>>, TError,{pollId: string;data: VoteOnPollBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof voteOnPoll>>, {pollId: string;data: VoteOnPollBody}> = (props) => {
          const {pollId,data} = props ?? {};

          return  voteOnPoll(pollId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VoteOnPollMutationResult = NonNullable<Awaited<ReturnType<typeof voteOnPoll>>>
    export type VoteOnPollMutationBody = VoteOnPollBody
    export type VoteOnPollMutationError = void

    /**
 * @summary Vote on a poll
 */
export const useVoteOnPoll = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteOnPoll>>, TError,{pollId: string;data: VoteOnPollBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof voteOnPoll>>,
        TError,
        {pollId: string;data: VoteOnPollBody},
        TContext
      > => {

      const mutationOptions = getVoteOnPollMutationOptions(options);

      return useMutation(mutationOptions);
    }
    